export default "__VITE_ASSET__BLzQQyQu__"